import { Copy, Share2 } from "lucide-react";
import { toast } from "sonner";

export const InviteCode = ({ code, name, large }) => {
  const copy = async () => {
    const text = `Unisciti al mio torneo "${name}" su Social Betting! Codice invito: ${code}`;
    try {
      if (navigator.share && large) await navigator.share({ text });
      else {
        await navigator.clipboard.writeText(code);
        toast.success("Codice copiato");
      }
    } catch {
      toast.error("Impossibile copiare");
    }
  };
  return (
    <button
      onClick={copy}
      data-testid="invite-code-copy"
      className={`group flex items-center justify-between gap-4 rounded-xl border border-dashed border-emerald-500/60 bg-emerald-500/5 hover:bg-emerald-500/10 transition-colors ${large ? "w-full p-6" : "px-3 h-8"}`}
    >
      <span className={`font-mono tracking-[0.3em] text-emerald-400 ${large ? "text-3xl" : "text-sm"}`} data-testid="invite-code-value">{code}</span>
      {large ? <Share2 size={20} className="text-emerald-400" /> : <Copy size={14} className="text-emerald-400" />}
    </button>
  );
};
